import '@styles/webdesktop/stylesheets/baseNumeric.scss';
import React from 'react';
import { SvgIconType } from '../../../SvgIcon/SvgIconType';
import { NumericContainer } from '../../NumericComponents/NumericContainer/NumericContainer';
import { NumericInput } from '../../NumericComponents/NumericInput/NumericInput';
import { NumericArrows } from '../../NumericComponents/NumericArrows/NumericArrows';
import { NumericPrefix } from '../../NumericComponents/NumericPrefix/NumericPrefix';
import { useNumericArrows } from '../../NumericComponents/NumericArrows/useNumericArrows';
import { useNumericValidation } from '../../NumericComponents/NumericValidation/useNumericValidation';
import { validateStep } from '../../NumericComponents/NumericValidation/numericValidation';
import { useSLTPNumeric } from './useSLTPNumeric';
import { Size } from '@front/sharedcomponents/Variables';
import { ToggleButton } from '../../../ToggleButton/ToggleButton';
import { ToggleButtonType } from '../../../ToggleButton/ToggleButtonType';
import { NumericSeparator } from '../../NumericComponents/NumericSeparator/NumericSeparator';
export const SLTPNumeric = ({ value, variableTickList, offsetType, operationType, isSL, disabled, isTrStopButtonChecked, onValueChange, onTrStopButtonClick, validationCallback }) => {
    const { step, min, max, precision, prefix, onIncrement, onDecrement } = useSLTPNumeric({
        value,
        variableTickList,
        offsetType,
        operationType,
        isSL
    });
    const combinedValidationCallback = (params) => {
        const stepError = validateStep(params, step);
        if (stepError !== null) {
            return stepError;
        }
        if (validationCallback !== undefined) {
            return validationCallback(params);
        }
        return null;
    };
    const { validationError } = useNumericValidation({
        value,
        min,
        max,
        step,
        precision,
        validationCallback: combinedValidationCallback
    });
    const { handleIncrement, handleDecrement } = useNumericArrows({
        value,
        onIncrement,
        onDecrement,
        onValueChange
    });
    const buttonClassName = 'numeric-button';
    return (React.createElement(NumericContainer, { disabled: disabled, validationError: validationError },
        React.createElement(NumericInput, { value: value, step: step, onValueChange: onValueChange, min: min, max: max, precision: precision, onIncrement: onIncrement, onDecrement: onDecrement }),
        isValidString(prefix) && React.createElement(NumericPrefix, { prefix: prefix }),
        React.createElement(NumericArrows, { onIncrement: handleIncrement, onDecrement: handleDecrement }),
        isSL === true && (React.createElement(React.Fragment, null,
            React.createElement(NumericSeparator, null),
            React.createElement(ToggleButton, { icon: SvgIconType.TrailingStop, type: ToggleButtonType.Secondary, onClick: onTrStopButtonClick, checked: isTrStopButtonChecked, size: Size.Medium, className: buttonClassName, disabled: disabled })))));
};
